import { render, staticRenderFns } from "./customerModal.vue?vue&type=template&id=5f12e956&scoped=true&"
import script from "./customerModal.vue?vue&type=script&lang=js&"
export * from "./customerModal.vue?vue&type=script&lang=js&"
import style0 from "./customerModal.vue?vue&type=style&index=0&id=5f12e956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12e956",
  null
  
)

export default component.exports